import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
  Card,
  CardHeader,
  Heading,
  Tag,
  CardBody,
  Link,
} from "@chakra-ui/react";

import { getHumanReadableStepName } from "@constants";
import { NewItemCardContent } from "./newModuleTypes";

/**
 * Component to display the starting point for a kind of module.
 * @param {string} name Name component being started with
 * @param {string} step Step name used to link to the appropriate form
 * @param {'2S'|'PS'} moduleTag a utility tag to distinguish between 2S and PS modules.
 */
export function NewItemCard({ name, step, moduleTag }: NewItemCardContent) {
  return (
    <Card>
      <CardHeader>
        <Heading size="md">
          {name} <Tag>{moduleTag}</Tag>
        </Heading>
      </CardHeader>
      <CardBody>
        <Link as={ReactRouterLink} to={`/production/${step}`}>
          {getHumanReadableStepName(step)}
        </Link>
      </CardBody>
    </Card>
  );
}
